import {
  getPayment,
  getPaymentRestriction,
} from "Store/akaAdvice/interfaces/getters";
import {
  CoverageNeed,
  ProductCoverageName,
} from "../../interfaces/CollectiveAdvice";

import { UserAuthorizationLevel } from "Store/advice/interfaces";
import { isDefined } from "Utils/functions";
import { getLimitWithinRange } from "Utils/numberUtils";

interface AdviceValues {
  adviceValue: number;
  minAdviceValue: number;
  maxAdviceValue: number;
}

export const getCorrectAkaAdviceValues = (
  need: CoverageNeed,
  productCoverageName: ProductCoverageName,
  isAdvisor: boolean,
  overrideAuthLevel?: UserAuthorizationLevel,
): AdviceValues => {
  const payment = getPayment(need, productCoverageName);
  const { recommended, minValid, maxValid } = payment.advice;
  if (recommended === 0) {
    return {
      adviceValue: 0,
      minAdviceValue: 0,
      maxAdviceValue: 0,
    };
  }
  const { minPayouts, maxPayouts } = getPaymentRestriction(
    need,
    productCoverageName,
  );
  const userAuthorizationLevel = getAuthLevel(isAdvisor, overrideAuthLevel);
  const minPayout = minPayouts[userAuthorizationLevel];
  const maxPayout = maxPayouts[userAuthorizationLevel];
  return {
    adviceValue: getLimitWithinRange(recommended, minPayout, maxPayout),
    minAdviceValue: getLimitWithinRange(minValid, minPayout, maxPayout),
    maxAdviceValue: getLimitWithinRange(maxValid, minPayout, maxPayout),
  };
};

export const getAdviceValueOrMinPayout = (
  need: CoverageNeed,
  productCoverageName: ProductCoverageName,
  isAdvisor: boolean,
  overrideAuthLevel?: UserAuthorizationLevel,
): number => {
  const { adviceValue } = getCorrectAkaAdviceValues(
    need,
    productCoverageName,
    isAdvisor,
    overrideAuthLevel,
  );
  const minPayout = getPaymentRestriction(need, productCoverageName).minPayouts[
    getAuthLevel(isAdvisor, overrideAuthLevel)
  ];
  return adviceValue === 0 ? minPayout : adviceValue;
};

export const getAuthLevel = (
  isAdvisor: boolean,
  overrideAuthLevel?: UserAuthorizationLevel,
): UserAuthorizationLevel => {
  if (isDefined(overrideAuthLevel)) {
    return overrideAuthLevel;
  }
  return isAdvisor
    ? UserAuthorizationLevel.PRODUCT_MANAGER
    : UserAuthorizationLevel.CUSTOMER;
};
